var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "a-form-model",
        { attrs: { slot: "detail" }, slot: "detail" },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "名称" } },
                    [
                      _c("a-input", { staticStyle: { width: "85%" } }),
                      _c(
                        "a-button",
                        {
                          staticStyle: { left: "3%" },
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.languageModelOpen(
                                _vm.dataTable,
                                _vm.dataColumn,
                                _vm.nameLanguages
                              )
                            }
                          }
                        },
                        [_vm._v("语言")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }